module.exports = __webpack_public_path__ + "img/header-bg-2.2a9e5ce7.png";